// extracted by mini-css-extract-plugin
export default {"wrapper":"hayFRb","collapse":"Sdd9NV","collapseToggle":"mINZJU","noticeable":"XOUTZo"};